import React, { useCallback, useRef, useEffect } from 'react'
import { memo } from "react";
import "./video.css"

const Video = (props) => {

  const VideoSource = props.VideoURL;
  const actorName = props.actorName;
  const actorTitle = props.actorTitle;

  const poster = props.poster;
  const isAutoPlay = props.autoPlay === undefined ? true : false;

  const elementRef = useRef(null);
  const animateRef = useRef(null);

  const handleEvent = useCallback((event) => {
    // use a switch/case to check for each event
    if (event.type === 'playing') {
      // console.log(elementRef.current);
      // console.log("playing");
    }
    if (event.type === 'canplay') {
      // console.log(elementRef.current);
      // console.log("playing");
      elementRef.current.play();
    }

    if (event.type === 'pause') {
      //  console.log(elementRef.current);
    }
    if (event.type === 'ended') {
      if (props.updateVideoStatue) {
        props.updateVideoStatue(event.type, elementRef.current.getElementsByTagName("source")[0].src);
      }
    }
  }, [props, elementRef]);

  const playVideo = (newSrc) => {
    // console.log("new Src:", newSrc);
    elementRef.current.src = newSrc;
    //elementRef.current.play();
  }


  useEffect(() => {
    if (props.playVideo) {
      props.playVideo.current = playVideo;
    }
  })

  useEffect(() => {
    var currentObj = elementRef.current;
    // elementRef.addEventListener('loadstart', handleEvent);
    // elementRef.addEventListener('progress', handleEvent);
    // elementRef.addEventListener('canplay', handleEvent);
    // elementRef.addEventListener('canplaythrough', handleEvent);
    // elementRef.addEventListener('ended', handleEvent);
    // elementRef.addEventListener('pause', handleEvent);
    // elementRef.addEventListener('play', handleEvent);
    // elementRef.addEventListener('playing', handleEvent);
    // elementRef.addEventListener('ratechange', handleEvent);
    // elementRef.addEventListener('seeking', handleEvent);
    // elementRef.addEventListener('stalled', handleEvent);

    ['loadstart', 'ended', 'canplay', 'playing', 'pause' /* all the other events */].forEach(event =>
      currentObj.addEventListener(event, handleEvent)
    )
    return () => {
      if (currentObj) {
        ['loadstart', 'ended', 'canplay', 'playing', 'pause' /* all the other events */].forEach(event =>
          currentObj.removeEventListener(event, handleEvent)
        )
      }

    }
  }, [elementRef, handleEvent]);

  return (
    <div className="Video" ref={animateRef}>
      {isAutoPlay ?

        <video width="350" height="622" preload="true" autoPlay playsInline ref={elementRef} poster={poster}>
          <source src={VideoSource} type="video/mp4" />
        </video>

        :

        <video width="350" height="622" playsInline ref={elementRef} poster={poster}>
          <source src={VideoSource} type="video/mp4" />
        </video>

      }


      <div className="actor">
        <div className='actorName'>{actorName}</div>
        <div className='actorTitle'>{actorTitle}</div>
      </div>
    </div>
  );
}

export default memo(Video);